// Cashier-side Evaluation Session bridge. This module is the only place that
// translates the backend response into the small state the Customer Display
// publisher needs. Staff JWTs and the original document id never enter the
// customer-facing protocol.

import { getWorkstationId } from '@shared/customer-display/workstationId';

const STATUSES = [
  'waiting',
  'rated',
  'timeout',
  'cancelled_by_new_document',
  'closed_without_payment',
];

const RATING_VALUES = [1, 2, 3];

export const PAYMENT_REFRESH_TIMEOUT_MS = 1500;

export function isEvaluationSessionEnabled(branch) {
  return Boolean(branch && branch.setting && branch.setting.service_rating_mode === 'customer_display');
}

export function workstationId() {
  return getWorkstationId();
}

export function mapEvaluationSession(result) {
  if (!result || typeof result !== 'object') return null;
  const id = String(result._id || '').trim();
  const ratingToken = String(result.rating_token || '').trim();
  if (!id || !ratingToken) return null;
  if (STATUSES.indexOf(result.status) === -1) return null;
  const rating = Number(result.rating);
  return {
    id,
    ratingToken,
    status: result.status,
    expiresAt: String(result.expires_at || '').trim(),
    rating: RATING_VALUES.indexOf(rating) === -1 ? null : rating,
  };
}

export async function fetchEvaluationSession(vm, documentId, options = {}) {
  const id = String(documentId || '').trim();
  if (!id) return null;
  const token = vm.$jwt.sign(
    { document_id: id, workstation_id: workstationId() },
    vm.$privateKey,
    { noTimestamp: true }
  );
  const url = `${vm.$baseUrl}/evaluation_session/get_or_create`;
  const body = { token };
  const response = options.timeout
    ? await vm.$axios.post(url, body, { timeout: options.timeout })
    : await vm.$axios.post(url, body);
  return response && response.status === 'success' ? mapEvaluationSession(response.result) : null;
}
